<template>
     <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <b-container v-else>
        
        <router-link class="admin-link" to="/Admin/Bot/Filters">&larr; Перейти к фильтрам</router-link>

        <b-row>
            <b-col class="pt-38">
                <span class="admin-title">{{header}}</span>
            </b-col>
        </b-row>
        <hr class="my-4">

        <b-row class="mb-13">
            <b-col class="p-0">
                <label for="form">Выберите опрос*</label>
                <custom-multiselect id="form"
                                    trackBy="id"
                                    label="name"
                                    v-model="form"
                                    :options="forms"/>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="3" class="mt-10">
                <label>Выберите CSV*</label>
            </b-col>
            <b-col class="mt-7">
                <open-file-dialog v-model="csv" 
                                  accept=".csv"
                                  :url-file-open="model.FileUrl" 
                                  :is-image="true" />
            </b-col>
        </b-row>

        <hr class="my-4">

        <b-row class="m-0">

            <b-col cols="2" class="p-0 mr-10">
			    <b-button block 
                          id="admin-btn-save"
                          class="admin-button"    
                          @click="saveFilter">
                    Сохранить
                </b-button>
            </b-col>

            <b-col cols="2" class="p-0">
			    <b-button block v-if="id"
                          id="admin-btn-cancel"
                          class="admin-button" 
                          @click="deleteFilterDialog">
                    Удалить
                </b-button>
            </b-col>

		</b-row>


    </b-container>
</template>
<script>

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import AllRoutes from '@/routes/all.routes'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import YesNoInput from '@/components/shared/YesNoInput'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import OpenFileDialog from '@/components/shared/OpenFileDialog'

import FileObject from '@/store/models/admin/standardBooks/FileObject'

export default {
    computed: {
        header: function() {
            return this.id == null ? "Создание фильтра" : "Редактирование фильтра";
        }
    },
    data: function() {
        let load = new Loading();

        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id 
                    : null;  

        this.getFormsLinks(load);
        if(id)
            this.getFilter(id, load);
        return {
            load: load,

            id: id,
            model: {
                Id: null,
                FileUrl: null
            },
            csv: new FileObject(),

            form: null,
            forms: []
        }
    },
    methods: {
        getFilter: function(id, load) {
            load.Calculate(true);
            
            apiService.Admin.Bot.Filters.Get(id)
                .then(response => {
                    this.model = response.data;
                    this.form = { id: this.model.BotFormId, name: this.model.BotFormName }
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },
        getFormsLinks: function(load) {
            load.Calculate(true);
            
            apiService.Admin.Bot.Filters.GetFormsLinks()
                .then(response => {
                    this.forms = response.data;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },
        saveFilter: function () {
            if(!this.form || (!this.csv.IsUpload() && !this.model.FileUrl)){
                dialogService.showAlert('Предупреждение', 'Не выбран опрос или не прикреплен CVS фийл');
                return;
            }	

            this.load.Calculate(true);
            let body = {
                Id: this.model.Id,
                BotFormId: this.form.id,
                BotFormName: this.form.name,
                File: this.csv.IsUpload() ? this.csv : null
            }
            apiService.Admin.Bot.Filters.PostCreateOrUpdate(body)
                .then(() => this.$router.push(AllRoutes.Admin.Bot.Filters.Index))
                .catch(() => this.load.Calculate(false));
        },
        deleteFilterDialog: function() {
            if(!this.id)
                return;

            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данный фильтр?')
                .then(() => this.deleteFilter())
                .catch(() => {});
        },
        deleteFilter: function() {
            apiService.Admin.Bot.Filters.Delete(this.id)
                .then(() => this.$router.push(AllRoutes.Admin.Bot.Filters.Index))
                .catch(() => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        YesNoInput,
        CustomMultiselect,
        OpenFileDialog
    }
}
</script>